<template>
  <div class="inline-loader-container">
    <img :style="`width: ${size}px;`" src="../../img/Edukate_Loader.svg" alt="Edukate loader">
  </div>
</template>

<style scoped>
.inline-loader-container img {
  height: auto;
}
</style>

<script>

export default {
  props: {
    size: {
      type: Number,
      default: 35,
    },
  },
};
</script>
